import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
// import Home from './home'
import Provider from "./context/store";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from '@react-oauth/google';
const clientId = "461021362222-3m2e12g5pqbrjgj3qmpqdtval68mv9c8.apps.googleusercontent.com"
ReactDOM.render(
  <Router>
    <Provider>
      <GoogleOAuthProvider clientId={clientId}>
        <App />
      </GoogleOAuthProvider>
    </Provider>
  </Router>,
  document.getElementById('root')
);
reportWebVitals();